import { UserContext, VehicleType } from "@tm/models"
import { ajaxAuth } from "@tm/utils"
import { WebserviceUrl } from "../../webserviceUrls"
import { isAutocompleteEnabled, shouldUseVersion2 } from "../helpers"
import type { ModelHit } from "./models"

function getEndpointUrl(userContext: UserContext, vehicleType: VehicleType | undefined): string | undefined {
    if (shouldUseVersion2(userContext)) {
        switch (vehicleType) {
            case VehicleType.PassengerCar:
                return `${WebserviceUrl.DataPickerV2}/CarModels`
            case VehicleType.Motorcycle:
                return `${WebserviceUrl.DataPickerV2}/BikeModels`
            default:
                return undefined
        }
    }

    switch (vehicleType) {
        case VehicleType.PassengerCar:
            return `${WebserviceUrl.DataPickerV1}/CarModels`
        default:
            return undefined
    }
}

type Request = {
    query: string
    resultSize?: number
}

type Response = {
    hits: ModelHit[]
}

export async function getModels(userContext: UserContext, query: string, vehicleType?: VehicleType): Promise<ModelHit[]> {
    if (!isAutocompleteEnabled(userContext)) {
        return []
    }

    const url = getEndpointUrl(userContext, vehicleType)

    if (!url) {
        return []
    }

    try {
        const { hits = [] } =
            (await ajaxAuth<Response, Request>({
                url,
                body: {
                    query,
                    resultSize: 50,
                },
            })) ?? {}

        return hits
    } catch {
        return []
    }
}
